import React from 'react';
import { useSelector } from 'react-redux';
import DefaultQuestion from '../defaultQuestion';
import s from './index.module.scss';

function FrequencyAndDuration (props) {
	const questions = useSelector((state) => state.questions.list);
	const { isThisCurrentStep } = props;
	const { isCurrentStepCompleted } = props;
	const isThisCurrentStepClass = isThisCurrentStep ? s.stepSelected : '';
	const isThisStepCompletedClass = isCurrentStepCompleted ? s.stepCompleted : '';

	return (
		<div className={`${s.step} ${isThisCurrentStepClass} ${isThisStepCompletedClass}`}>
			<DefaultQuestion step={questions.frequency} index={1} />
			<DefaultQuestion step={questions.duration} index={1} />
		</div>
	);
}

export default FrequencyAndDuration;
